export const draggableConstants = {
  LONG_PRESS_SEC: 500
}
